import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsuarioEmpresaEditarRoutingModule } from './usuario-empresa-editar-routing.module';
import { UsuarioEmpresaEditarComponent } from './usuario-empresa-editar.component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { DialogModule } from 'primeng/dialog';
import { TreeTableModule } from 'primeng/treetable';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';


@NgModule({
  declarations: [
    UsuarioEmpresaEditarComponent
  ],
  imports: [
    CommonModule,
    UsuarioEmpresaEditarRoutingModule,
    FormsModule,
    ButtonModule,
    InputTextModule,  
    DividerModule,
    MessagesModule,
    FormatPipeModule,
    DialogModule,
    TreeTableModule,
    ProgressSpinnerModule,
    TooltipModule,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService]
})
export class UsuarioEmpresaEditarModule { }
